<template>
    <div class="FilterPanel_item clearfix">
        <span class="FilterPanel_item_name">{{title}}</span>
        <div class="mFilterPanel_item_con">
            <template v-for="(item,index) in options">
              <a :key="index" href="javascript:void(0);" @click="SelectItem(item,index)" :class="{selected:item.selected}">{{item.item}}</a>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props:['value','title','options'],
    data(){return{
        selected_index:0
    }},
    created(){
        this.InitSelect();
    },
    methods:{
        SelectItem(_item,_index){
            this.$set(this.options[this.selected_index],"selected",false);
            this.$set(_item,"selected",true);
            this.selected_index=_index;
            this.$emit('input', _item.value);
        },
        InitSelect(){
            this.selected_index=0;
            var has_selected=false;
            if (this.value){
                this.options.map(function(_item,_index){
                    if (_item.value==this.value){
                        this.selected_index=_index;
                        this.$set(_item,"selected",true);
                        has_selected=true;
                    }else{
                        this.$set(_item,"selected",false);
                    }
                }.bind(this));
            }
            //默认选中
            if (!has_selected&&this.options.length>0){
                if (this.options[0].value==""||this.options[0].value==0){
                    this.$set(this.options[0],"selected",true);
                }
            }
        }
    },
    watch:{
        value(){
            this.InitSelect();
        },
        options(){
            this.InitSelect();
        }
    }
}
</script>